import { Component } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
  imports:     [
    NgIf,
    MatProgressSpinner,
  ],
  selector:    'app-loader',
  templateUrl: './loader.component.html',
  styleUrls:   ['./loader.component.scss'],
  standalone:  true,
})
export class LoaderComponent {
  public loaderStyle: 'material' | 'custom-tailwind' = 'material';
}
